import React from 'react';
import { Scale, X, Check } from 'lucide-react';
const rows = [{
  sin: 'Improvisar cada crisis',
  con: '4 protocolos de emergencia listos'
}, {
  sin: 'No saber qué hacer a las 11PM',
  con: 'Protocolo nocturno paso a paso'
}, {
  sin: 'La escuela no entiende a tu hijo',
  con: 'Manual listo para entregar a la maestra'
}, {
  sin: 'No podés salir tranquilo/a',
  con: 'Kit de bolsillo en tu cartera'
}, {
  sin: 'Las victorias se olvidan',
  con: 'Planner que registra cada logro'
}, {
  sin: 'Consultas médicas vagas',
  con: 'Informe mensual listo para el terapeuta'
}, {
  sin: 'Cada crisis parece el fin del mundo',
  con: 'Un sistema que sabe qué hacer'
}];
export function CostOfInaction() {
  return <section className="py-12 md:py-16 bg-cream" data-id="element-33">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-34">
        <div className="text-center mb-10" data-id="element-35">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6 shadow-sm border border-stone-200" data-id="element-36">
            <Scale className="w-8 h-8 text-stone-600" data-id="element-37" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-teal-900 mb-4" data-id="element-38">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-200" data-id="element-39">
          <div className="grid grid-cols-2" data-id="element-40">
            <div className="bg-coral-50/50 p-6 text-center border-b border-r border-stone-200" data-id="element-41">
              <h3 className="font-bold text-coral-900 flex items-center justify-center gap-2" data-id="element-42">
                <X className="w-5 h-5 text-coral-500" data-id="element-43" /> Sin el Sistema
              </h3>
            </div>
            <div className="bg-teal-50/50 p-6 text-center border-b border-stone-200" data-id="element-44">
              <h3 className="font-bold text-teal-900 flex items-center justify-center gap-2" data-id="element-45">
                <Check className="w-5 h-5 text-teal-500" data-id="element-46" /> Con Método
                Conecta-TEA
              </h3>
            </div>
          </div>

          <div className="divide-y divide-stone-100" data-id="element-47">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-stone-50 transition-colors" data-id="element-48">
                <div className="p-4 md:p-6 text-sm md:text-base text-stone-600 border-r border-stone-100 flex items-center" data-id="element-49">
                  {row.sin}
                </div>
                <div className="p-4 md:p-6 text-sm md:text-base font-medium text-teal-900 flex items-center bg-teal-50/20" data-id="element-50">
                  {row.con}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-51">
          <p className="text-2xl font-heading italic text-amber-600" data-id="element-52">
            La primera ficha señalada puede cambiarlo todo.
          </p>
        </div>
      </div>
    </section>;
}